export function log(txt) {
  console.log(txt);
}
export async function timeout(miliseconds) {
  await new Promise(resolve => {
    setTimeout(resolve, miliseconds);
  });
}
